<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="text-primary">Credentials</h4>
      <button
        type="button"
        class="close-modal mt-1"
        (click)="close()"
        aria-label="Close"
      >
        <i class="icon-cross-small"></i>
      </button>
    </div>
    <div class="modal-body text-center">
      <div class="modal-text">
        <div class="creditonal-details">
          <p class="note-danger p-2">
            Note:- This Key can only be download once to keep your account
            secure.This is the time we will show you the key secret.
          </p>
          <div class="form-group">
            <div class="position-relative">
              <input
                type="text"
                id="clientId"
                class="form-control floating"
                placeholder="Client Id"
                style="padding: 19px"
                name="clientId"
                readonly
                [value]="data?.client_id"
              />
              <label class="d-flex" for="clientId">Client Id -</label>
              <div (click)="copyText(data?.client_id)">
                <ng-container *ngTemplateOutlet="copy"> </ng-container>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="position-relative">
              <input
                type="text"
                id="clientSecret"
                class="form-control floating"
                placeholder="Client Secret"
                name="clientSecret"
                readonly
                [value]="data?.client_secret"
              />
              <label class="d-flex" for="keySecret">Client Secret</label>
              <div (click)="copyText(data?.client_secret)">
                <ng-container *ngTemplateOutlet="copy"> </ng-container>
              </div>
            </div>
          </div>
          <div class="form-group position-relative">
            <div class="position-relative">
              <input
                type="text"
                id="enciv"
                class="form-control floating"
                name="enckey"
                readonly
                [value]="data?.enciv"
                placeholder="AES ENCRYPTION IV"
              />
              <label class="d-flex" for="enciv">AES ENCRYPTION IV</label>
            </div>
            <div (click)="copyText(data?.enciv)">
              <ng-container *ngTemplateOutlet="copy"> </ng-container>
            </div>
          </div>
          <div class="form-group position-relative">
            <div class="position-relative">
              <input
                type="text"
                id="enckey"
                class="form-control floating"
                name="enckey"
                readonly
                [value]="data?.enckey"
                placeholder="AES ENCRYPTION KEY"
              />
              <label class="d-flex" for="enckey">AES ENCRYPTION KEY</label>
              <div (click)="copyText(data?.enckey)">
                <ng-container *ngTemplateOutlet="copy"> </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center w-100 modal-buttom">
        <!-- <button type="reset" class="btn btn-outline-danger px-5 py-2 m-2">      Reset    </button> -->
        <button
          type="submit"
          class="btn btn-outline-primary m-2"
          (click)="close()"
        >
          Okay
        </button>
        <button type="submit" class="btn btn-primary m-2" (click)="submit()">
          Download Key
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #copy>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_2309_9826)">
      <path
        d="M7 9.667C7 8.95967 7.28099 8.28131 7.78115 7.78115C8.28131 7.28099 8.95967 7 9.667 7H18.333C18.6832 7 19.03 7.06898 19.3536 7.20301C19.6772 7.33704 19.9712 7.53349 20.2189 7.78115C20.4665 8.0288 20.663 8.32281 20.797 8.64638C20.931 8.96996 21 9.31676 21 9.667V18.333C21 18.6832 20.931 19.03 20.797 19.3536C20.663 19.6772 20.4665 19.9712 20.2189 20.2189C19.9712 20.4665 19.6772 20.663 19.3536 20.797C19.03 20.931 18.6832 21 18.333 21H9.667C9.31676 21 8.96996 20.931 8.64638 20.797C8.32281 20.663 8.0288 20.4665 7.78115 20.2189C7.53349 19.9712 7.33704 19.6772 7.20301 19.3536C7.06898 19.03 7 18.6832 7 18.333V9.667Z"
        stroke="#062745"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.012 16.737C3.70534 16.5622 3.45027 16.3095 3.27258 16.0045C3.09488 15.6995 3.00085 15.353 3 15V5C3 3.9 3.9 3 5 3H15C15.75 3 16.158 3.385 16.5 4"
        stroke="#062745"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2309_9826">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs></svg></ng-template>
